// extracted by mini-css-extract-plugin
export default {"Area":"Verify_Area__qe-Mx"};